import React from 'react';
import { Controller, ControllerProps, useFormContext } from 'react-hook-form';
import { TextField } from '@schuettflix/planum-react';

export type TextFieldInputProps = Pick<ControllerProps, 'name' | 'defaultValue' | 'disabled'> & {
    label?: string;
    leadingSlot?: React.ReactNode;
    className?: string;
    size?: 'md' | 'lg';
    placeHolder?: string;
    dataTest?: string;
    onTextFieldChange?: (value: string | undefined) => void;
};

export const TextFieldInput = React.forwardRef<HTMLInputElement, TextFieldInputProps>(
    (
        {
            name = 'name',
            label,
            leadingSlot,
            disabled,
            defaultValue,
            className,
            placeHolder,
            onTextFieldChange,
            size,
            dataTest,
        },
        _ref
    ) => {
        const { control } = useFormContext();

        return (
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue ?? ''}
                render={({ field: { onChange, value, ...field }, fieldState }) => (
                    <TextField
                        {...field}
                        value={value ?? ''}
                        label={label}
                        leadingSlot={leadingSlot}
                        size={size}
                        disabled={disabled}
                        data-test={dataTest}
                        className={className}
                        onChange={event => {
                            const value = event.target.value;

                            onTextFieldChange?.(value);
                            onChange(value);
                        }}
                        error={fieldState.error?.message}
                        placeholder={placeHolder}
                    />
                )}
            />
        );
    }
);
